import axios from "axios";
import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const UPDATE_PASSWD = `${API_URL}/usuariosihrus/actualizarPasswd`;

export async function updatePasswd(newPasswd ,newPasswdRep) {
    return await axios({
      method: "PUT",
      url: `${UPDATE_PASSWD}`,
      params:{
        newPasswd:newPasswd,
        newPasswdRep:newPasswdRep
      }
    })
      .then((response) => response.data)
      .catch(
        (response) =>
          (response.data = "Error: Fallo al actualizar la contraseña del usuario")
      );
  }